export default {
    studios:{
        studio:'Студия'
    }
}